import { Pipe, PipeTransform } from '@angular/core';
import { format, parseISO } from 'date-fns';

@Pipe({
  name: 'dateUtcFormat',
  pure: true
})
export class DateUtcFormat implements PipeTransform {
  transform(date, formatValue): any {
    if (!date) {
      return;
    }
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    const utcDate = new Date(
      parsedDate.getUTCFullYear(),
      parsedDate.getUTCMonth(),
      parsedDate.getUTCDate(),
      parsedDate.getUTCHours(),
      parsedDate.getUTCMinutes(),
      parsedDate.getUTCSeconds()
    );
    return format(utcDate, formatValue);
  }
}
